import { MarkdownRenderEngine } from "./renderEngine";
import * as plugins from "./plugins";
var markdownRenderEngine = {
  name: "markdown-render-engine",
  component: MarkdownRenderEngine,
  sourceTypes: ["markdown", "md"]
};
export { markdownRenderEngine, plugins };